<div *ngIf="currentUser">

  <table class="table" style="background-color:white;">
    <tr>
      <td style="background-color:#0f2b46;color:white;" colspan="2"> API Key </td>
      <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
    </tr>
  </table>

  <div class="container">   
    <div class="row">      
      <div class="col-12" >
        <div class="row">
          <div class="col-6">
            <p><b>User Name</b> :   {{username}}</p>
          </div>
          <div class="col-6">
            <p><b>API KEY</b> :   {{password}}</p>
          </div>
        </div>
      </div>      
    </div>
  </div>
</div>

